import type { WhitelistItem } from "@gearbox-protocol/cli-utils";
import { Button } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import { useToggle } from "react-use";

import WhitelistKeepOpenDialog from "./WhitelistKeepOpenDialog";

interface KeepOpenActionProps {
  items: WhitelistItem[];
}

const KeepOpenAction: FC<KeepOpenActionProps> = ({ items }) => {
  const [open, toggleOpen] = useToggle(false);

  return (
    <>
      <Button onClick={toggleOpen} variant="ghost">
        Delete closed accounts
      </Button>

      {open && (
        <WhitelistKeepOpenDialog whitelist={items} onClose={toggleOpen} />
      )}
    </>
  );
};

export default KeepOpenAction;
